import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/generic/JwtService';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';

@Injectable({
  providedIn: 'root'
})
export class TablesAgGridService extends JwtService {

  constructor(private http: HttpClient,
              public override router: Router,
              public override modalComponent: NewModalService) { 
    super(router, modalComponent); 
  }

  listAllComuni(): Promise<any> {
    const options = this.getOptions();
    return this.http.get('https://axqvoqvbfjpaamphztgd.functions.supabase.co/comuni', options).toPromise()
      .then(res => res)
      .catch(this.handleError.bind(this));
  }

  getApiUrl(urlApi: string): Promise<any> {
    const options = this.getOptions();
    return this.http.get(urlApi, options).toPromise()
      .then(res => res)
      .catch(this.handleError.bind(this));
  }
}
